<script setup lang="ts">
import type { Components } from '@/api/generated/api';
import CustomSeparator from '@/core/elements/CustomSeparator.vue';
import ExternalMaterialRow from '@/core/supportMeasures/ExternalMaterialRow.vue';

const props = withDefaults(
  defineProps<{
    materials: readonly Components.Schemas.ExternalMaterialLinkDto[];
    readonly?: boolean;
    disabled?: boolean;
    removable?: boolean;
    noteTone?: boolean;
    density?: 'default' | 'protocol';
    surface?: 'primary' | 'secondary';
  }>(),
  { density: 'default', removable: false, noteTone: false, surface: 'secondary' },
);

const emit = defineEmits<{ 'update:materials': [ids: number[]] }>();

const removeMaterial = (id: number): void => {
  if (props.readonly || props.disabled) return;
  emit(
    'update:materials',
    props.materials.map((material) => material.externalMaterialId).filter((materialId) => materialId !== id),
  );
};
</script>

<template>
  <div
    v-if="materials.length"
    class="w-full rounded-2xl py-sm"
    :class="surface === 'primary' ? 'bg-surface-primary shadow-cookie-banner' : 'bg-surface-secondary'"
  >
    <template v-for="(material, index) in materials" :key="material.id">
      <CustomSeparator v-if="index > 0" class="mx-md my-sm" />
      <ExternalMaterialRow
        :material="material"
        :removable="removable"
        :disabled="disabled"
        :note-tone="noteTone"
        :density="density"
        @remove="removeMaterial(material.externalMaterialId)"
      />
    </template>
  </div>
</template>
